import error from '../common/error';
import api from '../js/api';
import emailInput from '../common/emailInput';
import desc from '../common/desc';
import title from '../common/title';
import button from '../common/button';
export default {
  name: 'emailparent',
  props: {
    wayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      email: '',
      errorTxt: '',
      cover: false
    };
  },
  computed: {
    actBtn: function actBtn() {
      return !!this.email && !this.errorTxt;
    }
  },
  components: {
    'error-tip': error,
    'email-input': emailInput,
    'button-wrap': button,
    'desc-txt': desc,
    'title-txt': title
  },
  methods: {
    changeErrorTxtHandle: function changeErrorTxtHandle(txt) {
      this.errorTxt = txt;
    },
    changeEmailHandle: function changeEmailHandle(email) {
      this.email = email;
    },
    next: function next() {
      var _this = this;
      if (this.email && !this.errorTxt && !this.cover) {
        this.cover = true;
        api.userIsExist("".concat(this.email)).then(function (data) {
          // 12007 12006 12005账号存在
          if (data.ret === '12007' || data.ret === '12006' || data.ret === '12005') {
            _this.$emit('inputEmail', 'login', _this.email);
          } else {
            _this.$emit('inputEmail', 'reg', _this.email);
          }
          _this.cover = false;
        }).catch(function (response) {
          _this.cover = false;
          if (response.errorMessageTMXTip) {
            return;
          }
          _this.errorTxt = _this.$t(_this.$loginLangPrefix('userSign.sysError'));
        });
      }
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};